import React from 'react';
import Image from '../../../components/Image/Image';

const CheckoutSublocation = ({ selectedSublocation, selectedCarBrand }) => (
    <div className="uk-flex uk-flex-wrap uk-flex-auto">
        <div className="uk-flex uk-flex-auto uk-card uk-card-small uk-card-body uk-padding-remove-vertical uk-padding-small one_location">
            <div className="uk-margin-small-right">
                <Image src={`https://techno-images.s3.eu-central-1.amazonaws.com/images/brand-icons/${selectedCarBrand}.jpeg`} alt="Logo" width="50px" />
            </div>
            <div className="adress_list_item">
                <div className="uk-text-bold">{selectedSublocation.anschrift.firma}</div>
                <div className="uk-flex uk-margin-small-top uk-margin-small-bottom">
                    <div className="uk-flex-left uk-margin-small-right map-marker">
                        <i className="fa fa-map-marker" aria-hidden="true" />
                    </div>
                    <div className="uk-flex-right location-text">
                        <div>{selectedSublocation.anschrift.strasse}</div>
                        <div>
                            <span>{selectedSublocation.anschrift.plz}</span> <span>{selectedSublocation.anschrift.ort}</span>
                        </div>
                        <div>
                            <b>{selectedCarBrand} </b>Markenwerkstatt
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="uk-flex-left location_image uk-hidden">
            <Image
                className="uk-width-1-1"
                alt="Autohaus"
                src={`https://techno-images.s3.eu-central-1.amazonaws.com/autohaus/${selectedSublocation.url}.jpg`}
            />
        </div>
    </div>
);

export default CheckoutSublocation;
